import { AirportOption } from "@airhelp/react";
import analytics, { analyticsGA4 } from "../../../../tracking/analytics";
import { claim_process, cta_click, search_airport } from "../../../../tracking/ga4/events/other";
import { readableChannel } from "../../../../tracking/utils/readableChannel";
import { Currency } from "../../../../app-settings/localesAndCurrencies";
import { buildEcommerce } from "../builders/ga4/ecomerceBuilder";
import { detectActionByEnquiryStatus, getProductName } from "./utils";
import { isFuture } from "date-fns";

/** New event vent sent upon selecting a future date in calendar and clicking continue */
export function trackFutureFlightSelected(flightDate?: Date | null) {
  if (flightDate && isFuture(flightDate)) {
    analyticsGA4.track("claim_process", {
      label: "future-date",
      action: "EnquiryStepComplete",
    });
  }
}

/** Event sent after claim creation with future flight */
export function trackFutureFlightEnquiryCreated(flightDate?: Date | null) {
  if (flightDate && isFuture(flightDate)) {
    analyticsGA4.track("claim_process", {
      event: "claim_process",
      label: "future-flight",
      action: "EnquiryStepComplete",
    });
  }
}

export function trackSearchAirport(
  autocompleteName: string,
  option: AirportOption,
  searchTerm: string,
) {
  if (autocompleteName === "departureAirport") {
    analyticsGA4.track(
      "search_airport",
      search_airport("departure", option.value.name, searchTerm),
    );
  } else if (autocompleteName === "arrivalAirport") {
    analyticsGA4.track(
      "search_airport",
      search_airport("destination", option.value.name, searchTerm),
    );
  }
}

export function trackCtaClick(label: string, placement: string) {
  analyticsGA4.track("cta_click", cta_click(label, placement));
}

export function trackViewItem({ currency }: { currency: Currency }) {
  analyticsGA4.track("view_item", {
    ecommerce: buildEcommerce({ currency }),
  });
}

export function trackClaimProcess({
  funnelStep = "unknown",
  isEligible,
}: {
  funnelStep?: string;
  isEligible?: boolean;
}) {
  const claimProcessAction = detectActionByEnquiryStatus({ isEligible });
  analyticsGA4.track("claim_process", claim_process(funnelStep, claimProcessAction));
}

export function trackProductSelected({
  departedFromIata,
  finalDestinationIata,
  regulation,
  currency,
  airlineName,
  channel = "ch_web",
  brandName = "Airhelp",
}: {
  currency: Currency;
  departedFromIata?: string;
  finalDestinationIata?: string;
  airlineName?: string;
  brandName?: string;
  regulation?: string;
  channel?: "ch_web" | "ch_ota" | "ch_partner" | "ch_mobile";
}) {
  analytics.track("productSelected", {
    tripDeparture: departedFromIata,
    tripDestination: finalDestinationIata,
    regulation: regulation,
    ecommerce: {
      currencyCode: currency,
      add: {
        products: [
          {
            quantity: 1,
            brand: brandName,
            variant: airlineName,
            name: getProductName(brandName),
            airhelpChannel: readableChannel(channel),
          },
        ],
      },
    },
  });
}
